<template>
  <div class="publishing">
    <div class="bg">
      <video src="@/assets/top-bg-video.mp4" autoplay loop muted ref="video" v-if="!$store.state.isMobile"></video>
      <div class="title">SUBMIT YOUR GAME!</div>
      <div class="content">Congratulations! You’re about to take your first step to success in the Chinese market.</div>
    </div>
    <form class="form-wrapper" @submit="_sendDeveloperInfo">

      <div class="title">Your Game</div>
      <div class="col-2">
        <div class="input-ctrl">
          <div class="label">Game Title <span>*</span></div>
          <input type="text" v-model="sendData.game_name" placeholder="Game Title" required>
        </div>
        <div class="input-ctrl">
          <div class="label">Is Your Game Live On Store? <span>*</span></div>
          <select v-model="sendData.status" required>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="input-ctrl">
          <div class="label">Gameplay Video Link <span>*</span></div>
          <input type="text" v-model="sendData.gameplay_video_link" placeholder="Gameplay Video Link" required>
        </div>
        <div class="input-ctrl">
          <div class="label">Client-Side Technology <span>*</span></div>
          <select v-model="sendData.app_platform" required>
            <option>Unity</option>
            <option>Cocos2D-X</option>
            <option>Buildbox</option>
            <option>Native</option>
            <option>Corona</option>
            <option>Other</option>
          </select>
        </div>
      </div>
      <div class="input-ctrl">
        <div class="label">Link to Store (iOS App Store/Google Play) <span v-if="sendData.status == 1">*</span></div>
        <input type="text" v-model="sendData.game_link" placeholder="Link to Store (iOS App Store/Google Play)" :required="sendData.status == 1">
      </div>
      <div class="input-ctrl">
        <div class="label">Tell Us About Your Game</div>
        <textarea rows="5" placeholder="Tell Us About Your Game" v-model="sendData.about_game"/>
      </div>

      <div class="title">Your Team</div>
      <div class="col-2">
        <div class="input-ctrl">
          <div class="label">Studio Name <span>*</span></div>
          <input type="text" v-model="sendData.team_name" placeholder="Studio Name" required>
        </div>
        <div class="input-ctrl">
          <div class="label">Team Size <span>*</span></div>
          <input type="number" v-model="sendData.team_size" placeholder="Team Size" required>
        </div>
      </div>
      <div class="col-2">
        <div class="input-ctrl">
          <div class="label" id="multiple-select">Website</div>
          <input type="text" v-model="sendData.team_website" placeholder="Website">
        </div>
        <div class="input-ctrl">
          <div class="label">Development Platform <span>*</span></div>
          <!-- <select v-model="sendData.development_platform" required multiple>
            <option>iOS</option>
            <option>Android</option>
            <option>Steam</option>
            <option>PC</option>
          </select> -->
          <vue-multi-select
          v-model="sendData.development_platform"
          :options="['iOS','Android','Steam','PC']"
          placeholder=""
          ></vue-multi-select>
        </div>
      </div>

      <div class="title">Your Contact Information</div>
      <div class="col-2">
        <div class="input-ctrl">
          <div class="label">Full Name <span>*</span></div>
          <input type="text" v-model="sendData.full_name" placeholder="Full Name" required>
        </div>
        <div class="input-ctrl">
          <div class="label">Email Address <span>*</span></div>
          <input type="text" v-model="sendData.email" placeholder="Email Address" required>
        </div>
      </div>
      <div class="col-2">
        <div class="input-ctrl">
          <div class="label">Skype ID <span>*</span></div>
          <input type="text" v-model="sendData.skype_id" placeholder="Skype ID" required>
        </div>
        <div class="input-ctrl">
          <div class="label">Country <span>*</span></div>
          <input type="text" v-model="sendData.country" placeholder="Country" required>
        </div>
      </div>
      <div class="col-2">
        <div class="input-ctrl">
          <div class="label">Language <span>*</span></div>
          <input type="text" v-model="sendData.language" placeholder="Language" required>
        </div>
        <div class="input-ctrl occupation" style="visibility: hidden">
          <div class="label"></div>
          <input type="text">
        </div>
      </div>
      <div class="submit-wrapper">
        <img :src="'data:image/png;base64,' + code.captcha" class="code" @click="_getCode">
        <input type="text" placeholder="Please enter verification code" v-model="sendData.captcha" required>
        <button type="submit" class="btn" @click="test">Submit</button>
      </div>
    </form>
    <div class="mask" v-if="showSuccess || showError">
      <div class="wrapper success" v-if="showSuccess">
        <div class="title">Success</div>
        <div class="content">{{ message }}</div>
        <button class="success" @click="showSuccess = false">OK</button>
      </div>
      <div class="wrapper error" v-if="showError">
        <div class="title">Failure</div>
        <div class="content">{{ message }}</div>
        <button class="error" @click="showError = false">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getCode, sendDeveloperInfo } from '@/api/req'
import VueMultiSelect from "vue-simple-multi-select"
export default {
  components: {
    VueMultiSelect
  },
  data() {
    return {
      sendData: {
        status: 1,
        app_platform: 'Unity',
        development_platform: []
      },
      code: {},
      showSuccess: false,
      showError: false,
      message: ''
    }
  },
  activated() {
    this._getCode()
    if(!this.$store.state.isMobile) {
      this.$refs.video.play()
    }
  },
  methods: {
    _getCode() {
      getCode().then(res => {
        this.code = res.data.data
      })
    },
    test() {
      if(this.$store.state.isMobile) return
      setTimeout(() => {
        window.scrollTo(0, (document.documentElement.scrollTop || document.body.scrollTop) - 150)
      })
    },
    _sendDeveloperInfo(e) {
      e.preventDefault()
      if(!this.sendData.development_platform.length) {
        this.message = 'Please select Development Platforms'
        this.showError = true
        window.location.hash = 'multiple-select'
        setTimeout(() => window.location.hash = 'publishing')
        return
      }
      this.sendData.en = this.code.en
      sendDeveloperInfo(this.sendData).then(res => {
        this.message = res.data.message
        if(res.data.code == 200) {
          this.sendData = {
            status: 1,
            app_platform: 'Unity',
            development_platform: []
          }
          this.showSuccess = true
        } else {
          this.showError = true
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.active 
  background-color black

.multi-select-wrapper 
	display block
	font-size 16px

.search-input 
	color black

.pill 
	padding .5em

.publishing
  background #fff

.bg
  position relative
  height 438px
  background url('../assets/top-bg.png') no-repeat center top
  background-size cover
  color #ffffff
  text-align center
  display flex
  flex-direction column
  justify-content center

  @media screen and (max-width: 769px)
    justify-content flex-start

  .title
    position relative
    font-size 64px
    font-weight 300

    @media screen and (max-width: 769px)
      font-size 35px
      margin-top 100px 
  
  .content
    position relative
    font-size 24px
    max-width 585px
    margin 70px auto 0 auto

    @media screen and (max-width: 769px)
      font-size 18px
      padding 0 22px

  video 
    position absolute
    left 50%
    top 0
    transform translateX(-50%)

    @media screen and (max-width: 769px)
      display none

.input-ctrl
  margin 20px 0

  .label
    font-size 24px
    color #535353

    @media screen and (max-width: 769px)
      font-size 16px

    span 
      color #D20707

  input, textarea, select
    font-family 'Avenir', Helvetica, Arial, sans-serif
    border 1px solid #D2D2D2
    outline none
    margin-top 10px
    width 100%
    box-sizing border-box

  input
    height 30px
  
  select 
    height 34px

.form-wrapper
  max-width 1400px
  margin 0 auto
  padding 70px 0
  background #FFFFFF
  box-shadow 0px 0px 62px 0px rgba(0, 0, 0, 0.11)
  padding 20px 100px 100px 100px
  box-sizing border-box

  @media screen and (max-width: 769px)
    padding 30px

  .title
    font-size 42px
    margin 80px 0 20px 0

    @media screen and (max-width: 769px)
      font-size 24px
      font-weight bold
      margin 0
      text-align center

  .col-2
    display flex

    @media screen and (max-width: 769px)
      flex-wrap wrap
    
    .input-ctrl
      width 50%
      margin 20px 50px

      &.occupation
        @media screen and (max-width: 769px)
          display none
      
      @media screen and (max-width: 769px)
        width 100%
        margin 20px 0

      &:first-child
        margin-left 0

      &:last-child
        margin-right 0

.submit-wrapper
  display flex
  align-items center
  justify-content center
  margin-top 100px

  @media screen and (max-width: 769px)
    margin-top 25px
    flex-wrap wrap

  .code
    width 140px
    height 34px

    @media screen and (max-width: 769px)
      width 92px

  input 
    border 1px solid #D2D2D2
    outline none
    width 400px
    height 30px
    margin 0 20px

    @media screen and (max-width: 769px)
      width auto
      flex-grow 1
      margin 0

  button

    @media screen and (max-width: 769px)
      width 100%
      margin-top 15px

.tips
  color red
  font-size 14px
  text-align center
  margin-top 10px

.mask
  position fixed
  left 0
  top 0
  bottom 0
  width 100%
  background rgba(0, 0, 0, .6)
  z-index 99999999

  .wrapper
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    width 290px
    height 235px
    text-align center
    padding 0 20px
    box-sizing border-box

    &.success
      background url('../assets/success.png') no-repeat center center
      background-size cover

    &.error
      background url('../assets/error.png') no-repeat center center
      background-size cover

    .title
      font-size 27px
      margin-top 90px

    .content
      font-size 16px
      margin-top 10px

    button
      border none
      color #ffffff
      font-size 13px
      width 150px
      height 32px
      border-radius 4px
      margin-top 20px

      &.success
        background #72C444

      &.error
        background #E5264E
</style>